<template>
  <b-row class="mt-3">
    <b-col md="3">
      <b-card class="rent-info-box">
        <strong>Primeira Janela:</strong>
        <div>{{ formatCurrency(valueFirstPeriod) }}</div>
      </b-card>
    </b-col>

    <b-col md="3">
      <b-card class="rent-info-box">
        <strong>Segunda Janela:</strong>
        <div>{{ formatCurrency(valueSecondPeriod) }}</div>
      </b-card>
    </b-col>

    <b-col md="3">
      <b-card class="rent-info-box">
        <strong>Total:</strong>
        <div>{{ formatCurrency(total) }}</div>
      </b-card>
    </b-col>

    <b-col md="3">
      <UpdateValues
        :selectedDate="selectedDate"
        @success="handleSuccess"
        @error="showErrorToast"
      />
    </b-col>
  </b-row>
</template>

<script>
import { BCard, BRow, BCol, BButton, BToast } from "bootstrap-vue";
import UpdateValues from "./Button/UpdateValues.vue";
export default {
  props: {
    valueFirstPeriod: {
      type: Number,
      required: true,
    },
    valueSecondPeriod: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    selectedDate: { type: String, required: true },
  },
  methods: {
    handleSuccess() {
      this.showSuccessToast();
      this.$emit("refresh-data");
    },
    formatCurrency(value) {
      if (typeof value !== "number") return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    showSuccessToast() {
      this.$bvToast.toast("Valores atualizados com sucesso!", {
        title: "Sucesso",
        variant: "success",
        solid: true,
        toaster: "b-toaster-top-right",
      });
    },
    showErrorToast(err) {
      this.$bvToast.toast("Erro ao atualizar valores.", {
        title: "Erro",
        variant: "danger",
        solid: true,
        toaster: "b-toaster-top-right",
      });
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BToast,
    UpdateValues,
  },
};
</script>

<style>
.rent-info-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  background-color: #f1f1f1;
  margin-bottom: 20px;
}
.rent-info-box {
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  flex: 1;
  text-align: center;
  font-size: 1.1rem;
  font-weight: bold;
  color: #333;
}
</style>